import { AxiosResponse } from "axios";
import axios from "@axios/axiosInstance";
import { useCallback } from "react";
import type { IuseApiHook } from "@src/types/AppTypes";

const useApiHook = ({ url, method }: IuseApiHook) => {
  const callback = useCallback(
    async <T,>(
      data?: any,
      additionalArg?: string,
      headers?: any
    ): Promise<AxiosResponse<T, any>> => {
      if (!navigator.onLine) {
        // Handle offline case
        throw new Error("No internet connection");
      }
      switch (method) {
        case "get":
          return axios.get<T>(url + (additionalArg ?? ""), headers);
        case "post":
          return axios.post<T>(url + (additionalArg ?? ""), data, headers);
        case "put":
          return axios.put<T>(url + (additionalArg ?? ""), data, headers);
        case "delete":
          return axios.delete<T>(url + (additionalArg ?? ""), {
            data,
          });
        default:
          break;
      }
      return new Promise(() => {});
    },
    [url, method]
  );

  return callback;
};

export default useApiHook;
